import * as tracking from 'dibs-tracking';
import serverVars from 'server-vars';

import { getQueryParam } from '../../utils/uriUtils.ts';
import { getSkuTrackingParams } from './helpers/getSkuTrackingParams.js';

const trackedProductDetailDimensions = [
    'onSale',
    'newListing',
    'dealerName',
    'dealerID',
    'dealerLocation',
    'itemPostingLocation',
    'purchaseStatus',
    'askingPrice',
    'priceType',
];

const {
    trackingConstants: { ECOM_PRODUCT_CLICK, ECOM_PRODUCT_DETAIL },
    eventNameConstants: { EVENT_SELECT_ITEM, EVENT_VIEW_ITEM, EVENT_PRODUCT_INTERACTION },
    interactionTypeConstants: { INTERACTION_TYPE_PDP, INTERACTION_TYPE_MAKE_OFFER },
    stepInteractionConstants: {
        STEP_INTERACTION_ENTRY,
        STEP_INTERACTION_RECOMMENDATION_VIEW_ALL_CLICK,
    },
    triggerConstants: { TRIGGER_MORE_FROM_DEALER_TAB },
} = tracking;

function getDefaultTrackingFields(item) {
    const itemInfo = item.pdpTrackingVpvParams || {};
    const locale = serverVars.get('locale');
    const name = locale === 'en-US' ? itemInfo.itemName : 'n/a';

    return {
        brand: itemInfo.dealerId,
        ...(item.browseUrl ? { category: item.browseUrl } : {}),
        categoryCode: item.categoryCode,
        dimension83: item?.contemporaryTrackingString || itemInfo?.contemporary,
        name,
        id: itemInfo.itemId,
        ...(item.firstPhotoWebPath ? { image: item.firstPhotoWebPath } : {}),
        ...(itemInfo.url ? { url: itemInfo.url } : {}),
    };
}

function trackEmailRecommendedItem(item) {
    const uriRef = global?.location?.search;
    const term = getQueryParam(uriRef, 'utm_term');

    /**
     * Tracks only if opened from transactional emails recommended items list.
     */
    if (term === 'recommendedItemsCarousel') {
        const list = 'email recommended items';

        tracking.trackEcommerce({
            type: ECOM_PRODUCT_CLICK,
            eventName: EVENT_SELECT_ITEM,
            actionField: { list, itemId: item.serviceId },
            products: [
                {
                    ...getDefaultTrackingFields(item),
                    variant: getQueryParam(uriRef, 'utm_campaign'),
                    list,
                },
            ],
        });
    }
}

export function trackEcommerce(item, skuId) {
    const pdpTrackingVpvParams = item.pdpTrackingVpvParams || {};
    const itemInfo = {
        ...pdpTrackingVpvParams,
        ...getSkuTrackingParams(pdpTrackingVpvParams, skuId),
    };
    tracking.trackEcommerce({
        type: ECOM_PRODUCT_DETAIL,
        eventName: EVENT_VIEW_ITEM,
        products: [
            {
                ...getDefaultTrackingFields(item),
                dimension12: itemInfo.dealerId,
                price: itemInfo.askingPrice,
                convertedAmounts: itemInfo.convertedAmounts,
                ...tracking.getCustomDimensions(itemInfo, trackedProductDetailDimensions),
            },
        ],
    });

    /**
     * Track ecommerce for items opened from email recommendations.
     */
    trackEmailRecommendedItem(item);
}

export function trackCarouselInteraction({
    action,
    image,
    totalImages,
    trigger = '',
    customLabel = '',
    stepInteractionName = '',
    interactionType = '',
}) {
    const label = customLabel || `${image + 1}/${totalImages}`; // adding 1 because we have 0 index
    tracking.trackEvent(
        {
            category: 'product',
            action,
            label,
            isInteractiveEvent: true,
            eventName: EVENT_PRODUCT_INTERACTION,
            interaction_type: interactionType || INTERACTION_TYPE_PDP,
            step_interaction_name: stepInteractionName,
            step_type: label,
            trigger,
        },
        null
    );
}

export function trackSellerDetailsView(isNegotiable, isVisible) {
    if (isVisible) {
        tracking.trackEvent({
            category: 'product',
            action: 'below the fold reached - seller details',
            label: 'pdp',
        });
        if (isNegotiable) {
            tracking.trackEvent({
                category: 'product',
                action: 'embedded make offer module reached',
                label: 'pdp',
                eventName: EVENT_PRODUCT_INTERACTION,
                interaction_type: INTERACTION_TYPE_MAKE_OFFER,
                step_interaction_name: STEP_INTERACTION_ENTRY,
                trigger: TRIGGER_MORE_FROM_DEALER_TAB,
            });
        }
    }
}

export function trackCarouselViewAllClick({ trigger = '', interactionType = 'Favorites module' }) {
    trackCarouselInteraction({
        action: STEP_INTERACTION_RECOMMENDATION_VIEW_ALL_CLICK,
        image: 1,
        totalImages: 1,
        trigger,
        customLabel: trigger,
        stepInteractionName: STEP_INTERACTION_RECOMMENDATION_VIEW_ALL_CLICK,
        interactionType,
    });
}
